export default "__VITE_ASSET__9eadbcdc__"